// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles":"98aaed3a0e956f889888","debug-page-model-style":"5f2580e99e12071992a6"}[chunkId] + ".css";
};